import React from "react";
import discImage from "../../../assets/images/form-mentoria-talento/Prueba-DISC_Mobile-desktop.png";
import "./DiscTestContent.scss";
import Button from "../..//atoms/button/button";

const DISC_TEST_URL = "https://www.potential-365.com/candidate/48e3daf6-3369-4d13-bcac-f55618c7c3b6"

const DiscTestContent = () => {
    return (
        <div className="disc-test-content">
            <h3 className="disc-title">
                Conoce tu tipo de personalidad para el empleo con la prueba DISC
            </h3>
            <p className="disc-description">
               Identifica habilidades, competencias y comportamientos que puedes potenciar para tu desarrollo profesional.
            </p>
            {/* <p className="disc-description">
                Podrás identificar rasgos de tu personalidad, habilidades,{" "}
                <br />
                competencias y comportamientos que puedes mejorar para potenciar
                tu desarrollo profesional.
            </p> */}

            <img src={discImage} alt="Prueba DICS" className="disc-img" />

            <h3 className="disc-title">Te tomará solo 15 minutos</h3>

            {/* <p className="disc-description">
                Al finalizar, recibirás un informe con información valiosa para
                tu crecimiento. En Mentoría de Talento te acompañaremos en la
                revisión de este informe.
            </p> */}
            <p className="disc-description">
                Al finalizar, recibirás un informe que revisaremos en la Mentoría de Talento Comfama.
            </p>

            <p className="disc-description">
               !Da el primer paso hacia tu desarrollo!
            </p>

            <Button
                type={"link"}
                text={"Comenzar"}
                classname={`a-button__magenta`}
                href={DISC_TEST_URL} 
                isDisabled={false}
            />

        </div>
    );
};

export default DiscTestContent;
